let initialState = null;

function in_sign_session(state = initialState, action) {
  if (action.type === "GET_INSIGN_SESSION_RESULT") {
    return action.res;
  } else return state;
}

export default in_sign_session;
